import { generateFileUrl } from "../apiHelper";

export const getNumberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const addDaysToDate = (date, days) => {
  const copy = new Date(Number(date));
  copy.setDate(date.getDate() + days);
  return copy;
};

export const subtractDaysFromDate = (date, days) => {
  const copy = new Date(Number(date));
  copy.setDate(date.getDate() - days);
  return copy;
};

export const getShuffledArray = (arr) => {
  let array = [...arr];
  var currentIndex = array.length,
    randomIndex;

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    --currentIndex;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

export const sliceArrayToChunks = (arr, chunks) => {
  const res = [];
  for (let i = 0; i < arr.length; i += chunks) {
    const chunk = arr.slice(i, i + chunks);
    res.push(chunk);
  }
  return res;
};

export const getListingImage = (listing) =>
  !!listing.streamId
    ? listing.photos[0]
    : generateFileUrl(listing.photos[0], listing._id);
